// export default IncidentRequest;
import React, { useEffect, useState } from "react";
import { FaBriefcase } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { CrimeReference } from "types";
import PageHeader from "../../components/PageHeader";
import { fetchCrimeReferences } from "../../services/incidentService";
import defaultAvatar from "../../images/avatar.png";

const tabs = ["All", "Approved", "Cancelled"];

const IncidentRequest: React.FC = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [incidents, setIncidents] = useState<CrimeReference[]>([]);
  const [search, setSearch] = useState("");
  const [dateFilter, setDateFilter] = useState<
    string | number | readonly string[] | undefined
  >();
  const navigate = useNavigate();

  useEffect(() => {
    fetchCrimeReferences().then(setIncidents).catch(console.error);
  }, []);

  const searchTerm = search.trim().toLowerCase();

  const filteredIncidents = incidents.filter((incident) => {
    // 1️⃣ — existing text‑search fields
    const uu_id = incident.uu_id?.toString()?.toLowerCase() || "";
    const receiving_prosecutor =
      incident?.receiving_prosecutor?.full_name?.toLowerCase() || "";
    const crime_type = incident.crime_type?.toString()?.toLowerCase() || "";
    const status = incident.status?.toString()?.toLowerCase() || "";
    const date_received = incident.date_received
      ? new Date(incident.date_received).toLocaleDateString().toLowerCase()
      : "";
    const crime_reference_number =
      incident.crime_reference_number?.toLowerCase() || "";

    const matchesText =
      receiving_prosecutor.includes(searchTerm) ||
      crime_type.includes(searchTerm) ||
      status.includes(searchTerm) ||
      date_received.includes(searchTerm) ||
      status.includes(searchTerm) ||
      crime_reference_number.includes(searchTerm);

    // let matchesDate = true;
    // if (dateFilter) {
    //   const dateField = incident.appliedDate; // e.g. "April 19, 2025"
    //   const d = new Date(dateField);

    //   // build a local YYYY-MM-DD string
    //   const year = d.getFullYear();
    //   const month = String(d.getMonth() + 1).padStart(2, "0");
    //   const day = String(d.getDate()).padStart(2, "0");
    //   const localYMD = `${year}-${month}-${day}`; // e.g. "2025-04-19"

    //   matchesDate = localYMD === dateFilter;
    // }
    // 3️⃣ — only keep items that match BOTH
    return matchesText;
  });

  return (
    <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
      {/* ✅ Page Header with icon, tabs, and right controls */}
      <PageHeader
        title="Incident Request"
        icon={FaBriefcase}
        tabs={tabs}
        activeTab={activeTab}
        onTabClick={setActiveTab}
        rightContent={
          <>
            <input
              type="date"
              className="px-3 py-2 text-sm text-gray-600 border rounded"
              placeholder="Filter by Date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            />
            <button
              onClick={() => navigate("/incident-register")}
              className="px-5 py-2 text-sm font-semibold text-white bg-red-600 rounded hover:bg-red-700"
            >
              Register Incident
            </button>
          </>
        }
      />
      {/* {activeTab === "All" ? (
        <AllTab incidents={filteredIncidents} />
      ) : activeTab === "Approved" ? (
        <ApprovedTab />
      ) : activeTab === "Cancelled" ? (
        <CancelledTab />
      ) : null} */}

      <div className="max-w-screen-xl ml-1 mr-4 space-y-6">
        <div className="overflow-hidden bg-white shadow rounded-xl">
          <table className="w-full text-sm border-collapse">
            <thead className="text-white bg-black">
              <tr>
                <th colSpan={7} className="p-4" rounded-t-lg>
                  <div className="flex items-center justify-between">
                    {/* Left: Back + Title */}
                    <div className="flex items-center gap-2 text-lg font-semibold">
                      <button
                        onClick={() => navigate(-1)}
                        className="text-white hover:text-gray-300"
                        title="Go Back"
                      >
                        ◀️
                      </button>
                      <span>Incidents List Table</span>
                    </div>

                    {/* Right: Search Box */}
                    <div className="relative w-80">
                      <span className="absolute inset-y-0 flex items-center text-gray-500 pointer-events-none left-3">
                        🔍
                      </span>
                      <input
                        type="text"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        placeholder="Search"
                        className="w-full py-2 pl-10 pr-4 text-sm text-black placeholder-gray-600 bg-gray-200 rounded-md focus:outline-none"
                      />
                    </div>
                  </div>
                </th>
              </tr>
              <tr>
                {/* <th className="p-3 text-left">Reporter</th> */}
                <th className="p-3 text-left">Prosecutor</th>
                <th className="p-3 text-left">Received Date</th>
                <th className="p-3 text-left">Status</th>
                <th className="p-3 text-left">Crime Ref No</th>
                <th className="p-3 text-left">Crime Type</th>
                <th className="p-3 text-left" rounded-tr-lg>
                  Add Select Result
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredIncidents.map((incident, idx) => (
                <tr
                  key={idx}
                  className={idx % 2 === 0 ? "bg-[#F7F4F1AB]" : "bg-white"}
                >
                  {/* <td className="p-3">
                    <div className="flex items-center gap-1">
                      <img
                        src={incident?.requestedBy?.img || defaultAvatar}
                        alt="avatar"
                        className="w-[56] h-[56] rounded-full"
                      />
                      <div className="relative top-5 right-5">
                        {incident?.requestedBy ? sealCheck : null}
                      </div>
                      <div
                      className={
                        incident?.requestedBy?.isApproved ? "pl-0" : "pl-6"
                      }
                      >
                        <div className="font-base font-[Poppins]">
                          {incident?.requestedBy?.name}
                        </div>
                        <div className="font-xs text-xs font-[Poppins]">
                          {incident?.requestedBy?.role}
                        </div>
                      </div>
                    </div>
                  </td> */}
                  <td className="p-3 font-[500] font-[Poppins]">
                    <div className="flex items-center gap-1">
                      <img
                        src={defaultAvatar}
                        // src={incident?.registeredBy?.img || defaultAvatar}
                        alt="avatar"
                        className="w-[40] h-[40] rounded-full"
                      />
                      <div className="ml-2">
                        <div className="font-base font-[Poppins]">
                          {incident?.receiving_prosecutor?.full_name}
                        </div>
                        <div className="font-xs text-xs font-[Poppins]">
                          Prosecutor
                        </div>
                      </div>
                    </div>
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    {incident.date_received
                      ? new Date(incident.date_received).toLocaleDateString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                          }
                        )
                      : "-"}
                  </td>
                  <td className="p-3 font-[500] font-[inter]">
                    <div className="px-4 py-1 bg-[#33333321] rounded-2xl border border-[#3D3D3D] text-center">
                      {incident?.status?.toString()?.toUpperCase()}
                    </div>
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    {incident?.crime_reference_number}
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    {incident?.crime_type?.toString()}
                  </td>
                  <td className="p-3 font-[500] font-[Poppins]">
                    <button className="px-4 py-1 text-sm bg-gray-200 rounded hover:bg-gray-300">
                      View
                    </button>
                  </td>
                </tr>
              ))}
              {incidents.length === 0 && (
                <tr>
                  <td colSpan={6} className="p-4 text-center text-gray-500">
                    No incidents found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default IncidentRequest;

